// extracted by mini-css-extract-plugin
module.exports = {"exCoPlayerWrapper":"exCoPlayer_exCoPlayerWrapper__1qV2b"};